// @flow
import { compose, pure } from 'recompose';
import React, { type Element } from 'react';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import { Alert, Grid } from 'angieslist-react-components';
import { getErrorMessage } from 'angieslist-app-platform';
import './unifiedBusinessListView.scss';
import BusinessList from './components/BusinessList';

import serviceProviderActions from '../../../app/common/serviceProvider/serviceProviderActions';
import type { BusinessListReducerState } from '../common/businessListReducer';

const prosPerPage = 20;

export type UnifiedBusinessListViewProps = {
  // redux
  businessList: BusinessListReducerState,
  // redux serviceProviderActions
  getCurrentUsersServiceProviders: typeof serviceProviderActions.getCurrentUsersServiceProviders,
};

export class UnifiedBusinessListViewComponent extends
  React.Component<UnifiedBusinessListViewProps> {
  componentDidMount() {
    const { getCurrentUsersServiceProviders } = this.props;

    // TODO make prosPerPage an API limit
    getCurrentUsersServiceProviders({ offset: 0, limit: prosPerPage, sortBy: 'name' });
  }
  props: UnifiedBusinessListViewProps;
  render(): Element<"div"> {
    const {
      businessList: {
        getCurrentUsersServiceProviders: {
          request,
          response,
          error,
        },
      },
    } = this.props;
    const { serviceProviders = [] } = response || {};
    const {
      offset = 0,
    } = request || {};
    const showBusinessList = (offset > 0) || (serviceProviders.length > 1 && offset === 0);

    return (
      <div className=".business-list--unified-view-centering">
        <Grid className="business-list--grid">
          <Choose>
            <When condition={!showBusinessList}>
              <If condition={error}>
                <Alert bsStyle="danger">
                  {getErrorMessage(error)}
                </Alert>
              </If>
              <div className="text-center">
                <i className="icon icon-load text-primary icon-pulse icon-5x text-center" />
              </div>
            </When>
            <Otherwise>
              <BusinessList />
            </Otherwise>
          </Choose>
        </Grid>
      </div>
    );
  }
}

export default (hot(module)(compose(
  connect(state => ({
    businessList: state.businessList,
  }), {
    ...serviceProviderActions,
  }),
  pure,
)(UnifiedBusinessListViewComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/UnifiedBusinessListView.js